import { useState } from "react";
import { Button } from "Components/Button";
import { RotateCcw, RotateCw } from "lucide-react";
import { Box } from "styles/globalComponents";
import { DocumentItem } from "./DocumentItem";

interface DocumentsProps {
  files: {
    id: string;
    file_path: string;
    filename: string;
    preview: string;
    isImage: boolean;
  }[];
}

export const Documents = ({ files }: DocumentsProps) => {
  const [tabSelected, setTabSelected] = useState(1);
  const currentFileView = files?.[tabSelected - 1];
  const [rotations, setRotations] = useState<{ [key: string]: number }>({});

  const currentRotation = currentFileView
    ? rotations[currentFileView.file_path] || 0
    : 0;

  const handleRotateLeft = () => {
    if (currentFileView) {
      setRotations((prev) => ({
        ...prev,
        [currentFileView.file_path]:
          (prev[currentFileView.file_path] || 0) - 90,
      }));
    }
  };

  const handleRotateRight = () => {
    if (currentFileView) {
      setRotations((prev) => ({
        ...prev,
        [currentFileView.file_path]:
          (prev[currentFileView.file_path] || 0) + 90,
      }));
    }
  };

  return (
    <div className="documents-preview-style">
      <div className="tabs">
        <Box display="flex" gap="5" wrap="wrap">
          {files?.map((file, index) => (
            <Button
              key={file.file_path}
              onClick={() => setTabSelected(index + 1)}
              outlined
              {...(index + 1 === tabSelected && { outlined: false })}
            >
              Arquivo {index + 1}
            </Button>
          ))}
        </Box>

        <Box display="flex" justify="end" gap="3">
          <Button onClick={handleRotateLeft} outlined>
            <RotateCcw size={16} />
            <span>Girar Esquerda</span>
          </Button>
          <Button onClick={handleRotateRight} outlined>
            <RotateCw size={16} />
            <span>Girar Direita</span>
          </Button>
        </Box>
      </div>

      <div className="documents-preview">
        {currentFileView && (
          <DocumentItem file={currentFileView} rotation={currentRotation} />
        )}
      </div>
    </div>
  );
};
